import { render } from "./PaginationCustom.vue?vue&type=template&id=3feeea18"
import script from "./PaginationCustom.vue?vue&type=script&lang=js"
export * from "./PaginationCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__